import { type HTMLProps, type ReactElement } from 'react';
import { type Graph, type Thing, type WithContext } from 'schema-dts';

import { type BasePageParams, getPageUrl } from '@/app/urls/url-mapping';

type Props = {
  structuredData: WithContext<Thing> | Graph;
} & HTMLProps<HTMLScriptElement>;

export const getRegionOrganizationUrl = (
  params: Pick<BasePageParams, 'language' | 'region'>
): string => {
  const homeParams =
    params.region === 'ww' ? { ...params, region: 'us' as const } : params;
  const homeUrl = getPageUrl('home', homeParams, { withOrigin: true }) ?? '';
  return `${homeUrl}/#organization`;
};

export const SeoStructuredDataScript = (props: Props): ReactElement => {
  const { structuredData, ...scriptProps } = props;

  return (
    <script
      // eslint-disable-next-line react/no-danger -- Recommended by Next
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(structuredData),
      }}
      type="application/ld+json"
      {...scriptProps}
    />
  );
};
